import { Component, OnInit } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { Upload } from '../uploads/upload';
import { Variavel } from '../variaveis/variavel';
import { Participante } from './../participantes/participante';

import { ParticipanteService } from './../participantes/participante.service';
import { VariavelService } from '../variaveis/variaveis.service';
import { UploadService } from '../uploads/upload.service';
import {environment} from "../../environments/environment";

import { PER_PAGE } from '../constante';

@Component({
  selector: 'app-participante',
  templateUrl: './participante.component.html',
  styleUrls: ['./participantes.css'],
  providers: [UploadService, ParticipanteService, VariavelService]
})
export class VerListaParticipanteComponent implements OnInit {

  titulo: string = "Participantes";
  uploads: Upload[];
  upload: Upload;
  params: any = {status: undefined, page: undefined};
  participantes: Participante[];
  variaveis: any;
  participanteId: number;
  uploadId: number;
  public busy: Promise<any>;
  public paginaAtual: number = 1;
  public totalItens: number = 1;
  public itensPorPagina: number = 1;

  constructor(
    private participanteService: ParticipanteService,
    private variavelService: VariavelService,
    private uploadService: UploadService,
    private route: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService
  ) {
    this.upload = new Upload();
  }

  getParticipantes(): void {
    this.route.params.forEach((queryString: Params) => {
      let id:number = queryString['id'];
      this.params.page = this.paginaAtual;
      this.busy = this.uploadService.getUpload(id, this.params)
              .then((upload) =>  this.carregar(upload));
    });
  }

  downloadParticipantes(): void{
    this.route.params.forEach((queryString: Params) => {
      let id:number = queryString['id'];
     
      let urlString = "";

      if(this.params.status != undefined){
        urlString += "?status="+this.params.status;
      }
      let url:string = environment.url_api + "/envios/"+ id + "/download" + urlString;
      window.open(url, '_blank');
      
    });
  }

  carregar(upload: any): void{
    this.upload = upload;
    this.participantes = upload.participantes.data;
    this.paginaAtual = upload.participantes.current_page;
    this.totalItens = upload.participantes.total;
    this.itensPorPagina = upload.participantes.per_page;
  }

  pageChanged(page: any): void{
    this.paginaAtual = page;
    this.getParticipantes();
  }

  getVariaveis(): void {
    this.route.params.forEach((params: Params) => {
      let id:number = params['id'];
      this.busy = this.variavelService.getVariaveis(id)
              .then((variaveis) =>  this.variaveis = variaveis);
    });
  }

  apagar(participante: Participante, upload: Upload): void {
    if(confirm('Deseja realmente excluir esse participante? Essa operação não pode ser revertida após a confirmação.')){
      this.busy = this.participanteService.deleteParticipante(participante.id, upload.id)
            .then(() => this.getParticipantes());
    }
  }

  modoEdicao(participante: Participante): void {
    participante.edicao = true;
  }

  salvarParticipante(participante: Participante): void {
      this.busy = this.participanteService.saveUpdateListaParticipante(participante, this.upload)
          .then(() => participante.edicao = false);
  }

  agendar(participanteId: number, uploadId: number): void {
    this.busy = this.participanteService.agendar(participanteId, uploadId);
  }

  confirmaEnvio(participanteId: number, uploadId: number) {
    if(confirm("Você deseja realmente enviar o Certificado por e-mail para este participante?")) {
        this.agendar(participanteId,uploadId);
    }
  }

  addParticipante(): void{
    let participante = new Participante();
    let vars: any = new Array();

    for(let index in this.variaveis){
      let variavel: any = new Object();
      variavel[this.variaveis[index].id] = "Any";
      vars.push(variavel);
    }

    participante.edicao = true;
    participante.variaveis = [new Variavel()];

    this.participantes.unshift(participante);
  }

  ngOnInit() {
    this.getVariaveis();
    this.getParticipantes();
  }

}



// WEBPACK FOOTER //
// ./src/app/lista-participantes/participante.component.ts